const formControlLabelFormCreateUser = {
  admin: 'Administrador',
  analyst: 'Analista',
  contractor: 'Empresa terceira'
};

export default formControlLabelFormCreateUser;
